import ScenarioPlanningToolPage from "@faire/prototype-playground/workspace/il/scenario-planning-tool";
import { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import AdsAdvancedSettingsPage from "../../workspace/il/ads-advanced-settings";
import AdsManager2Page from "../../workspace/il/ads-manager-2";
import AdsManager2ListenLabsPage from "../../workspace/il/ads-manager-2-listen-labs";
import AdsManager2OverviewPage from "../../workspace/il/ads-manager-2-overview";
import AdvancedSettingsEducationPage from "../../workspace/il/advanced-settings-education";

const AdsSettingsHistoryPage = lazy(
  () => import("../../pages/AdsSettingsHistoryPage")
);
const AdsSocialFeedPage = lazy(() => import("../../pages/AdsSocialFeedPage"));
const ChartMovementPage = lazy(() => import("../../pages/ChartMovementPage"));
const StepperResponsivenessPage = lazy(
  () => import("../../pages/StepperResponsivenessPage")
);

export function IreneLimbRoutes() {
  return (
    <Switch>
      <Route
        path="/il/ads-advanced-settings"
        component={AdsAdvancedSettingsPage}
      />
      <Route
        path="/il/ads-manager-2-overview"
        component={AdsManager2OverviewPage}
      />
      <Route
        path="/il/ads-manager-2-listen-labs"
        component={AdsManager2ListenLabsPage}
      />
      <Route path="/il/ads-manager-2-archived" component={AdsManager2Page} />
      <Redirect from="/il/ads-manager-2" to="/il/ads-manager-2-overview" />
      <Route
        path="/il/ads-settings-history"
        component={AdsSettingsHistoryPage}
      />
      <Route path="/il/ads-social-feed" component={AdsSocialFeedPage} />
      <Route
        path="/il/advanced-settings-education"
        component={AdvancedSettingsEducationPage}
      />
      <Route path="/il/chart-movement" component={ChartMovementPage} />
      <Route
        path="/il/scenario-planning-tool"
        component={ScenarioPlanningToolPage}
      />
      <Route
        path="/il/stepper-responsiveness"
        component={StepperResponsivenessPage}
      />
    </Switch>
  );
}

export const slug = "il";
